var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export default function OnboardingProgressBar(_a) {
    var progress = _a.progress;
    return (_jsx("div", __assign({ style: {
            position: "absolute",
            top: 0,
            width: "100%",
            height: 20,
            backgroundColor: "white",
        } }, { children: _jsx("div", { style: {
                transition: "300ms ease",
                height: "100%",
                width: "".concat(progress, "%"),
                backgroundColor: "#49beef",
                borderRadius: 2,
            } }) })));
}
